<template>
  <v-container fluid>
    <template v-if="useCanadaPost">
      <v-row>
        <v-col v-if="addingAddress" cols="12">
          <v-row>
            <v-col cols="12" md="6">
              <trans-select
                :label="$t('components.canada_post_address.country')"
                :item="selected"
                propertyName="Country"
                :items="options.Models.Country"
                :rules="[$rules.required]"
                class="required"
                clearable
              ></trans-select>
            </v-col>

            <template v-if="selected.Country">
              <v-col cols="12" md="6" v-if="selected.Country.IsOther">
                <no-autocomplete-textfield
                  :label="$t('headers.members_management.OtherCountry')"
                  v-model="otherCountry"
                  class="required"
                  :rules="[$rules.required]"
                ></no-autocomplete-textfield>
              </v-col>
              <v-col
                cols="12"
                md="6"
                v-if="
                  (selected.Country.IsOther && otherCountry !== null) ||
                  !selected.Country.IsOther
                "
              >
                <v-autocomplete
                  :label="
                    $t(
                      'components.canada_post_address.start_typing_your_address'
                    )
                  "
                  v-model="selectedAddress"
                  :items="searchResults"
                  return-object
                  :loading="isAddressSearchLoading"
                  :search-input.sync="searchValue"
                  item-text="Description"
                  item-value="Id"
                  clearable
                  append-outer-icon="mdi-magnify"
                  :rules="[$rules.required]"
                  class="required"
                  ref="addressList"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" align-self="center"></v-col>
              <v-col cols="12" md="6" align-self="center">
                <!-- <v-switch
                  v-model="useCanadaPost"
                  :label="$t('components.canada_post_address.use_canada_post')"
                /> -->
                <span>{{ $t("components.canada_post_address.use_form") }}</span>
                <v-btn
                  @click="useCanadaPost = false"
                  text
                  color="primary"
                  class="link"
                  style="padding:0!important"
                >
                  {{ $t("globals.here") }}
                </v-btn>
              </v-col>
            </template>
          </v-row>
        </v-col>
        <v-col cols="12" md="2" v-else>
          <!-- <span style="white-space: pre"> -->
          {{ fetchedAddress }}
          <!-- </span> -->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" align-self="center">
          <v-btn
            v-show="!addingAddress"
            color="primary"
            @click="
              fetchedAddress = undefined;
              selected.Country = undefined;
              selectedAddress = undefined;
              addingAddress = true;
              $emit('valid', false);
            "
            :disabled="readOnly"
          >
            <span>
              {{
                fetchedAddress === undefined
                  ? $t("globals.add")
                  : $t("globals.edit")
              }}
            </span>
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-form v-model="valid" ref="addressForm">
        <div class="row">
          <div class="col-12 col-md-4 col-lg-3">
            <trans-select
              @change="countryChanged"
              :clearable="true"
              :item="formAddress"
              propertyName="Country"
              :items="options.Models.Country"
              :label="$t('headers.members_management.Country')"
              :rules="isAddressRequired() ? [$rules.required] : []"
              :class="isAddressRequired() ? 'required' : ''"
            ></trans-select>
          </div>
          <div
            class="col-12 col-md-4 col-lg-3"
            v-if="formAddress.Country && formAddress.Country.IsOther"
          >
            <no-autocomplete-textfield
              :label="$t('headers.members_management.OtherCountry')"
              @input="formAddress.OtherCountry = $event"
              :rules="isAddressRequired() ? [$rules.required] : []"
              :class="isAddressRequired() ? 'required' : ''"
            ></no-autocomplete-textfield>
          </div>
          <div class="col-12 col-md-4 col-lg-3" v-if="formAddress.Country">
            <no-autocomplete-textfield
              :label="$t('headers.members_management.Street Number')"
              @input="formAddress.StreetNumber = $event"
              :rules="
                isAddressRequired()
                  ? [$rules.required, $rules.streetNumber]
                  : [$rules.streetNumber]
              "
              :class="isAddressRequired() ? 'required' : ''"
            ></no-autocomplete-textfield>
          </div>
          <div class="col-12 col-md-4 col-lg-3" v-if="formAddress.Country">
            <no-autocomplete-textfield
              :label="$t('headers.members_management.Street Name')"
              @input="formAddress.StreetName = $event"
              :rules="isAddressRequired() ? [$rules.required] : []"
              :class="isAddressRequired() ? 'required' : ''"
            ></no-autocomplete-textfield>
          </div>
          <div class="col-12 col-md-4 col-lg-3" v-if="formAddress.Country">
            <no-autocomplete-textfield
              :label="$t('headers.members_management.Suite Number')"
              @input="formAddress.SuiteNumber = $event"
            ></no-autocomplete-textfield>
          </div>
          <div class="col-12 col-md-4 col-lg-3" v-if="formAddress.Country">
            <no-autocomplete-textfield
              :label="$t('headers.members_management.City')"
              @input="formAddress.City = $event"
              :rules="isAddressRequired() ? [$rules.required] : []"
              :class="isAddressRequired() ? 'required' : ''"
            ></no-autocomplete-textfield>
          </div>
          <div
            class="col-12 col-md-4 col-lg-3"
            v-if="formAddress.Country && !formAddress.Country.IsOther"
          >
            <trans-select
              :clearable="!isAddressRequired()"
              :item="formAddress"
              propertyName="Province"
              :items="options.Models.Province"
              :label="$t('headers.members_management.Province')"
              :rules="isAddressRequired() ? [$rules.required] : []"
              :class="isAddressRequired() ? 'required' : ''"
            ></trans-select>
          </div>
          <div
            class="col-12 col-md-4 col-lg-3"
            v-if="formAddress.Country && formAddress.Country.IsOther"
          >
            <no-autocomplete-textfield
              :label="$t('headers.members_management.OtherProvince')"
              @input="formAddress.OtherProvince = $event"
              :rules="isAddressRequired() ? [$rules.required] : []"
              :class="isAddressRequired() ? 'required' : ''"
            ></no-autocomplete-textfield>
          </div>
          <div
            class="col-12 col-md-4 col-lg-3"
            v-if="formAddress.Country && !formAddress.Country.IsOther"
          >
            <no-autocomplete-textfield
              :label="$t('headers.members_management.Postal Code')"
              @input="formAddress.PostalCode = $event"
              :rules="
                isAddressRequired()
                  ? [$rules.required, $rules.postalCode]
                  : [$rules.postalCode]
              "
              :class="isAddressRequired() ? 'required' : ''"
              v-mask="postalCodeMask"
            ></no-autocomplete-textfield>
          </div>
          <div
            class="col-12 col-md-4 col-lg-3"
            v-if="formAddress.Country && formAddress.Country.IsOther"
          >
            <no-autocomplete-textfield
              :label="$t('headers.members_management.OtherPostalCode')"
              @input="formAddress.OtherPostalCode = $event"
              :rules="isAddressRequired() ? [$rules.required] : []"
              :class="isAddressRequired() ? 'required' : ''"
            ></no-autocomplete-textfield>
          </div>
          <div class="col-12 col-md-4 col-lg-3">
            <!-- <v-switch
              v-model="useCanadaPost"
              :label="$t('components.canada_post_address.use_canada_post')"
            /> -->
            <span>
              {{ $t("components.canada_post_address.use_canada_post") }}
            </span>
            <v-btn
              @click="useCanadaPost = true"
              text
              color="primary"
              class="link"
              style="padding:0!important"
            >
              {{ $t("globals.here") }}
            </v-btn>
          </div>
        </div>
      </v-form>
    </template>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { translate } from "../trans";
import TransSelect from "../components/TransSelect";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
export default {
  props: ["address", "readOnly", "stringAddress", "isRequired"],
  components: { TransSelect, NoAutocompleteTextfield },
  directives: { mask },
  data() {
    return {
      isAddressSearchLoading: false,
      isAddressRetrieveLoading: false,
      fetchedAddress: undefined,
      canadaPostAddress: undefined,
      addingAddress: false,
      addedAddress: false,
      selectedAddress: undefined,
      searchResults: [],
      selected: {
        Country: null,
      },
      searchValue: undefined,
      otherCountry: null,
      useCanadaPost: true,
      valid: false,
      formAddress: {},
      postalCodeMask: "A#A #A#",
      rules: {
        postalCode: (v) => {
          let val = this.unmask(v, this.postalCodeMask);
          return !val || this.$rules.postalCode(val);
        },
      },
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language", "settings"]),
  },
  watch: {
    "selected.Country": {
      handler(v) {
        console.log(v);
      },
      immediate: true,
    },
    useCanadaPost: {
      handler(v) {
        if (!v) {
          this.formAddress.Country = this.selected.Country;
        }
      },
    },
    // address: {
    //   handler(v) {
    //     if (v) {
    //       console.log(v)
    //       this.fetchedAddress = this.formatDrawbridgeAddress(v);
    //     }
    //   },
    //   immediate: true,
    // },
    searchValue: {
      async handler(v) {
        console.log(v, this.otherCountry);
        if (v === null) {
          return;
        }

        if (this.isAddressSearchLoading) {
          return;
        }
        this.isAddressSearchLoading = true;
        try {
          this.searchResults = (
            await this.canadaPostFind({
              payload: {
                Key: this.settings.CanadaPostKey,
                SearchTerm: this.searchValue,
                Country: this.selected.Country.IsOther
                  ? this.otherCountry
                  : this.selected.Country.Name,
                LanguagePreference: this.language.language.toUpperCase(),
              },
            })
          ).data.Items.map((o) => {
            o.Description = `${o.Text} ${o.Description}`;
            return o;
          });
          console.log(this.searchResults);
        } catch (error) {
          console.log(error);
        } finally {
          this.isAddressSearchLoading = false;
        }
      },
    },
    selectedAddress: {
      async handler(v) {
        console.log(v);
        if (v === null) {
          return;
        }
        if (this.isAddressRetrieveLoading) {
          return;
        }
        console.log(v, this.selectedAddress, this.otherCountry);
        if (this.selectedAddress.Next === "Find") {
          this.isAddressSearchLoading = true;
          try {
            let payload = {
              Key: this.settings.CanadaPostKey,
              SearchTerm: `${this.selectedAddress.Description}`,
              Country: this.selected.Country.IsOther
                ? this.otherCountry
                : this.selected.Country.Name,
              LanguagePreference: this.language.language.toUpperCase(),
            };
            if (this.selectedAddress.Id) {
              payload.LastId = this.selectedAddress.Id;
            }
            this.searchResults = (
              await this.canadaPostFind({
                payload: payload,
              })
            ).data.Items.map((o) => {
              o.Description = `${o.Text} ${o.Description}`;
              return o;
            });
            console.log(this.searchResults);
            this.searchValue = null;
            this.onFocus();
          } catch (error) {
            console.log(error);
          } finally {
            this.isAddressSearchLoading = false;
          }
        } else if (this.selectedAddress.Next === "Retrieve") {
          this.isAddressRetrieveLoading = true;
          try {
            this.canadaPostAddress = (
              await this.canadaPostRetrieve({
                payload: {
                  Key: this.settings.CanadaPostKey,
                  Id: this.selectedAddress.Id,
                  LanguagePreference: this.language.language.toUpperCase(),
                },
              })
            ).data.Items;
            console.log(this.canadaPostAddress);
            if (this.selected.Country.IsOther) {
              if (Array.isArray(this.canadaPostAddress)) {
                this.fetchedAddress = this.canadaPostAddress[0].Label;
              } else {
                this.fetchedAddress = this.canadaPostAddress.Label;
              }
            } else {
              this.fetchedAddress = this.canadaPostAddress.filter((o) =>
                this.language.language.toUpperCase() === "EN"
                  ? o.Language === "ENG"
                  : o.Language === "FRE"
              )[0].Label;
            }
            console.log(this.fetchedAddress, this.canadaPostAddress);
            this.addingAddress = false;
            this.addedAddress = true;
            this.$emit("update-address", this.fillMemberAddress());
            this.$emit("update-string", this.fetchedAddress);
            this.$emit("valid", true);
          } catch (error) {
            console.log(error);
          } finally {
            this.isAddressRetrieveLoading = false;
          }
        }
      },
    },
    // fetchedAddress: {
    //   handler(v) {
    //     console.log("valid: ", v!==null && v!==undefined);
    //     this.$emit("valid", v!==null && v!==undefined);
    //   }
    // }
  },
  mounted() {
    if (this.address) {
      this.fetchedAddress = this.formatDrawbridgeAddress(this.address);
      // for (let key of Object.keys(this.address)) {
      //   this.formAddress[key] = this.address[key];
      // }
    } else if (this.stringAddress) {
      this.fetchedAddress = this.stringAddress;
    }
  },
  methods: {
    ...mapActions("data", ["canadaPostFind", "canadaPostRetrieve"]),
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    countryChanged(country) {
      // console.log(JSON.stringify(country), JSON.stringify(this.formAddress.Country));
      if (country) {
        if (country.IsOther) {
          delete this.formAddress.Province;
          delete this.formAddress.PostalCode;
        } else {
          delete this.formAddress.OtherCountry;
          delete this.formAddress.OtherProvince;
          delete this.formAddress.OtherPostalCode;
        }
      } else {
        this.formAddress = {};
      }
      // this.$forceUpdate();
    },
    isAddressRequired() {
      if (this.isRequired) {
        this.$emit("update-address", this.fixMask(this.formAddress));
        this.$emit(
          "update-string",
          this.formatDrawbridgeAddress(this.formAddress)
        );
        this.$emit("valid", true);
        this.$emit("valid", this.valid);
        return true;
      }
      for (let key of Object.keys(this.formAddress)) {
        // console.log(key);
        if (
          this.formAddress[key] === undefined ||
          this.formAddress[key] === null ||
          this.formAddress[key] === ""
        ) {
          delete this.formAddress[key];
        }
      }
      // console.log(this.formAddress);
      if (Object.keys(this.formAddress).length === 0) {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
          this.dirty = false;
        }
        this.$emit("update-address", undefined);
        this.$emit("update-string", "");
        this.$emit("valid", true);
        return false;
      }
      console.log("#########################", this.formAddress);
      this.$emit("update-address", this.fixMask(this.formAddress));
      this.$emit(
        "update-string",
        this.formatDrawbridgeAddress(this.formAddress)
      );
      this.$emit("valid", true);
      this.$emit("valid", this.valid);
      return true;
    },
    onFocus() {
      this.$refs.addressList.isMenuActive = true;
    },
    fillMemberAddress() {
      let address;
      if (Array.isArray(this.canadaPostAddress)) {
        address = this.canadaPostAddress[0];
      } else {
        address = this.canadaPostAddress;
      }
      if (this.selected.Country.IsOther) {
        const ret = {
          StreetNumber: address.BuildingNumber,
          StreetName: address.Street,
          City: address.City,
          OtherProvince: address.Province,
          OtherPostalCode: address.PostalCode,
          OtherCountry: this.otherCountry,
          CountryId: this.selected.Country.Id,
          SuiteNumber: address.SubBuilding,
        };
        console.log(ret);
        return ret;
      } else {
        // address = this.canadaPostAddress.filter((o) =>
        //   this.language.language.toUpperCase() === "EN"
        //     ? o.Language === "ENG"
        //     : o.Language === "FRE"
        // )[0];
        let province = address.ProvinceCode;
        province = this.options.Models.Province.filter(
          (o) => o.Code === address.ProvinceCode
        );

        const ret = {
          City: address.City,
          ProvinceId: province.length > 0 ? province[0].Id : null,
          PostalCode: address.PostalCode,
          CountryId: this.selected.Country.Id,
        };
        if (
          address.Street !== null &&
          address.Street !== undefined &&
          address.Street !== ""
        ) {
          ret.StreetName = address.Street;
          ret.StreetNumber = address.BuildingNumber;
          ret.SuiteNumber = address.SubBuilding;
        } else if (
          address.Line1 !== null &&
          address.Line1 !== undefined &&
          address.Line1 !== ""
        ) {
          ret.StreetName = address.Line1;
        }
        return ret;
      }
    },
    // formatDrawbridgeAddress(address) {
    //   var res = "";
    //   if (address) {
    //     if (address.SuiteNumber) res += address.SuiteNumber;
    //     if (address.StreetNumber) {
    //       if (res.length > 0) res += " ";
    //       res += address.StreetNumber.toString();
    //     }
    //     if (address.StreetName) {
    //       if (res.length > 0) res += ", ";
    //       res += address.StreetName;
    //     }
    //     if (address.City) {
    //       if (res.length > 0) res += "\n";
    //       res += address.City;
    //     }
    //     if (address.Province) {
    //       if (res.length > 0) res += ", ";
    //       res += address.Province.Code;
    //     }

    //     if (address.PostalCode) res += " " + address.PostalCode;
    //     if (address.Country)
    //       res += "\n " + translate(address.Country, this.language.language);
    //   }
    //   return res;
    // },
    formatDrawbridgeAddress(address) {
      console.log(address);
      var res = "";
      if (address) {
        if (address.Address1) {
          res += address.Address1 + "\n";
          if (address.Address2) {
            res += address.Address2 + "\n";
            if (address.Address3) {
              res += address.Address3 + "\n";
            }
          }
        } else {
          if (address.SuiteNumber) {
            res += address.SuiteNumber;
          }
          if (address.StreetNumber) {
            if (res.length > 0) {
              res += " ";
            }
            res += address.StreetNumber.toString();
          }
          if (address.StreetName) {
            if (res.length > 0) {
              res += ", ";
            }
            res += address.StreetName;
          }
        }

        if (address.City) {
          if (res.length > 0) {
            res += "\n";
          }
          res += address.City;
        }
        if (address.Country && address.Country.IsOther) {
          if (address.OtherProvince) {
            if (res.length > 0) {
              res += ", ";
            }
            res += address.OtherProvince;
          }
          if (address.OtherPostalCode) {
            res += " " + address.OtherPostalCode;
          }
          if (address.OtherCountry) {
            res += "\n " + address.OtherCountry;
          }
        } else {
          if (address.Province) {
            if (res.length > 0) {
              res += ", ";
            }
            res += address.Province.Code;
          }
          if (address.PostalCode) {
            res += " " + address.PostalCode;
          }
          if (address.Country) {
            res += "\n " + translate(address.Country, this.language.language);
          }
        }
      }
      return res;
    },
    fixMask(addr) {
      let address = JSON.parse(JSON.stringify(addr));
      if (address.PostalCode !== null && address.PostalCode !== undefined) {
        address.PostalCode = this.unmask(
          address.PostalCode,
          this.postalCodeMask
        );
      }
      if (address.Country !== null && address.Country !== undefined) {
        address.CountryId = address.Country.Id;
        delete address.Country;
      }
      if (address.Province !== null && address.Province !== undefined) {
        address.ProvinceId = address.Province.Id;
        delete address.Province;
      }
      return address;
    },
  },
};
</script>

<style scoped>
.link {
  text-decoration: underline;
  text-transform: lowercase !important;
  padding: 0!important;
  margin: 0!important;
  min-width:0!important
}
</style>
